import React, { useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import ReLoginModal from "../ReLoginModal";
import ConfirmDeleteCustomer from "./ConfirmDeleteCustomer";

const EditDelete = ({ handlClose, customer }: any) => {
  const [mode, setMode] = useState("edit");
  const [loading, setLoading] = useState(false);
  const [reLogin, setReLogin] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };
  const amounts = customer?.customerAccount?.map(
    (acc: any) => acc?.balance?.amount
  );
  const totalAmount = amounts.reduce(
    (sum: any, amount: any) => sum + (amount || 0),
    0
  );

  const [edit, setEdit] = useState({
    businessName: customer.businessName,
    email: customer.email,
    phone: customer.phone,
    businessType: customer.businessType,
    address: customer.address,
    city: customer.city,
    state: customer.state,
    country: customer.country,
    amount: totalAmount,
    bank: customer?.customerAccount?.map((acc: any) => acc?.bank?.bankName),
  });


  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEdit((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleEditSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    axios
      .patch(
        `https://apibiz.oneflaretech.com/api/customer/${customer._id}`,
        {
          businessName: edit.businessName,
          email: edit.email,
          phone: edit.phone,
          businessType: edit.businessType,
          address: edit.address,
          city: edit.city,
          state: edit.state,
          country: edit.country,
          amount: edit.amount,
        },
        { headers: headers }
      )

      .then((res) => {
        console.log(res);
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          // cancelButtonColor: "red",
          confirmButtonText: "Continue",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
        handlClose();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          // cancelButtonColor: "red",
          confirmButtonText: "Try Again",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      <form onSubmit={handleEditSubmit} className="catModal">
        {reLogin ? <ReLoginModal /> : null}
        <div className="catModalTop">
          <h4>Edit or delete customer</h4>
          <ImCancelCircle className="catCancel" onClick={handlClose} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput">
          <input
            type="text"
            placeholder="Customer’s First name"
            name="businessName"
            value={edit.businessName}
            onChange={handleEditChange}
          />
          <div className="div modalDouble">
            <input
              type="text"
              placeholder="Customer’s last name"
              name="businessType"
              value={edit.businessType}
              onChange={handleEditChange}
            />
            <input
              type="tel"
              placeholder="Customer’s Phone Number"
              name="phone"
              value={edit.phone}
              onChange={handleEditChange}
            />
          </div>
          <input
            type="text"
            placeholder="Customer’s email address"
            name="email"
            value={edit.email}
            onChange={handleEditChange}
          />
          <input
            type="text"
            placeholder="Address"
            name="address"
            value={edit.address}
            onChange={handleEditChange}
          />
          <input
            type="text"
            placeholder="City"
            name="city"
            value={edit.city}
            onChange={handleEditChange}
          />
          <input
            type="tel"
            placeholder="State"
            name="state"
            value={edit.state}
            onChange={handleEditChange}
          />
          <input
            type="text"
            placeholder="Country"
            name="country"
            value={edit.country}
            onChange={handleEditChange}
          />

          <input
            type="text"
            name="amount"
            disabled
            value={edit?.amount}
            onChange={handleEditChange}
          />
          <input
            type="text"
            name="amount"
            value={edit?.bank}
            onChange={handleEditChange}
          />
        </div>

        <div className="catModalBtn">
          <button type="submit" className="catBtn1">
            {loading ? (
              mode === "edit" ? (
                <CircularProgress
                  style={{ color: "#fff", width: "25px", height: "25px" }}
                />
              ) : null
            ) : (
              "Editing"
            )}
          </button>
          <button className="productBtn2" type="button" onClick={handleConfirmDelete}>
            Delete
          </button>
        </div>
        {confirmDelete ? (
          <ConfirmDeleteCustomer
            handleConfirmDelete={handleConfirmDelete}
            edit={edit}
            customer={customer}
          />
        ) : null}
      </form>
    </div>
  );
};

export default EditDelete;
